// extracted by mini-css-extract-plugin
export default {"inputBox":"network-address-input_inputBox__D9q8v","ipInput":"network-address-input_ipInput__GIYYd","portInput":"network-address-input_portInput__y-eCv"};